const comments = [
  {
    name: '光影追梦人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20profile%20avatar%20with%20warm%20coral%20gradient%20circle%2C%20minimalist%20design%2C%20no%20text%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2天前',
    text: '用了好几个平台，最后还是回到6080影院。画质真的没话说，1080P清晰度在线看一点都不卡，片源更新也快，新片基本上映后很快就能看到高清版了。',
  },
  {
    name: '剧荒拯救者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20profile%20avatar%20with%20soft%20gold%20gradient%20circle%2C%20minimalist%20design%2C%20no%20text%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '5天前',
    text: '免费电视剧全集资源太全了！最近在追的几部韩剧和国产剧这里都有，不用到处找资源。推荐给朋友后他们也说好用，画质流畅度都很满意。',
  },
  {
    name: '周末电影控',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20profile%20avatar%20with%20warm%20terracotta%20gradient%20circle%2C%20minimalist%20design%2C%20no%20text%2C%20clean%20flat%20illustration%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '1周前',
    text: '作为电影爱好者，6080影院的专题分类做得特别好。动作、悬疑、科幻各种类型一目了然，周末窝在家一部接一部看，简直不要太爽！',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            听听影迷们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-100">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                "{comment.text}"
              </p>
              <div className="flex gap-0.5 mt-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}